import {Injectable} from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import {Observable} from 'rxjs';
import {DataService} from '../data.service';
import {FrtShipmentsAccessorials} from 'src/app/features/frt-shipment-accessorials/frt-accessorials';


@Injectable({
  providedIn: 'root'
})
export class FrtShipAccessorialsService extends DataService {


  private baseURI = this.apiUri + '/frtshipmentaccessorial/';

  constructor(http: HttpClient) {
    super(http);
  }

  findByShipment(shipmentsId): Observable<any> {
    this.setUri(this.baseURI + 'byshipment');
    let params: HttpParams = new HttpParams();
    params = params.set('shipmentId', '' + shipmentsId);
    return this.get({params});
  }

  getAccessorialsCost(shipmentsId, payload): Observable<any> {
    return this.http.post(this.baseURI + shipmentsId + '/getAccessorialsCost/', payload);
  }

  saveOrUpdateFrtAccessorials(frtBookShipArray: FrtShipmentsAccessorials[]): Observable<any> {
    this.setUri(this.baseURI + 'update/');
    return this.update(frtBookShipArray);
  }

  deleteByAccessorialsById(accessorialsId): Observable<any> {
    this.setUri(this.baseURI + 'deleteAccessorials');
    return this.update(accessorialsId);
  }
}

